// @flow
import * as React from 'react';

type Value = {};

const HeapContext = React.createContext<Value>({});

export const HeapProvider = ({ children }: { children: React.Node }) => {
  if (process.env.REACT_APP_HEAP_TRACKING_ID) {
    loadHeap({
      id: process.env.REACT_APP_HEAP_TRACKING_ID,
    });
  }

  return <HeapContext.Provider value={{}}>{children}</HeapContext.Provider>;
};

export default HeapContext;

/**
 * Function enables inserting heap.js into the page
 * @desc This is copy-paste script from below link
 * @link https://docs.heap.io/docs/web
 * @param {Props} { id, config }
 */
const loadHeap = ({ id, config }: { id: string, config?: any }) =>
  (function(window, document, script, appId, config) {
    window.heap = window.heap || [];
    window.heap.appid = appId;
    window.heap.config = config || {};
    const secure =
      (config && config.forceSSL) || 'https:' === document.location.protocol;
    const firstScript = document.getElementsByTagName(script)[0];

    const heapScript = document.createElement('script');
    heapScript.type = 'text/javascript';
    heapScript.async = true;
    heapScript.src =
      (secure ? 'https:' : 'http:') +
      '//cdn.heapanalytics.com/js/heap-' +
      appId +
      '.js';

    // $FlowFixMe
    firstScript.parentNode.insertBefore(heapScript, firstScript);

    const helper = function(name) {
      return function() {
        window.heap.push(
          [name].concat(Array.prototype.slice.call(arguments, 0))
        );
      };
    };

    const utils = [
      'addEventProperties',
      'addUserProperties',
      'clearEventProperties',
      'identify',
      'resetIdentity',
      'removeEventProperty',
      'setEventProperties',
      'track',
      'unsetEventProperty',
    ];

    for (var i = 0; i < utils.length; i++) {
      window.heap[utils[i]] = helper(utils[i]);
    }
  })(window, document, 'script', `${id}`, config);
